module.exports = __webpack_public_path__ + "assets/img/section-2-landing-page-h3-squad.745351f6.png";